import './SocialTemplatesTable.css';

import React from 'react';
import B2BTableInMemory from '../../b2b-common/B2BTableInMemory';
import { Add, CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const SocialTemplatesTable = ({ templates, onNewTemplate, onSelect, ...rest  }) => {

    const { t } = useB2BTranslation('b2b-social');

    const headers = [
        { label: t('Acronym'), align: 'center' },
        { label: t('Template name'), align: 'left' },
        { label: t('Description'), align: 'left' },
        { label: t('Scope'), align: 'center' },
        { label: t('Type'), align: 'center' },
        { label: t('Instances'), align: 'center' },
        { label: t('Enabled'), align: 'center' },
    ];

    const rows = templates ? templates.map((template) => ({
        id: template.socialPostTemplateId,
        cells: [
            { content: template.socialPostTemplateAcronym, align: 'center' },
            { content: template.socialPostTemplateName_label, align: 'left' },
            { content: template.socialPostTemplateDescription_label, align: 'left' },
            { content: template.socialPostScope, align: 'center' },
            { content: template.postTemplateType, align: 'center' },
            { content: template.totalInstances, align: 'center' },
            { content: template.socialPostTemplateEnabled ? <CheckBox /> : <CheckBoxOutlineBlank />, align: 'center' },
        ],
    })) : [];

    const handleSelectTemplate = (rowSelected) => {
        const selectedTemplate = templates.find((template) => template.socialPostTemplateId === rowSelected.id);
        onSelect && onSelect(selectedTemplate);
     }

    return (
        <B2BTableInMemory
            headers={headers}
            rows={rows}
            className={'social-templates-table'}
            numRows={10}
            stickyHeader={true}
            onRowClick={handleSelectTemplate}
            buttons={[
                { label: t('New template'), icon: <Add />, onClick: onNewTemplate }
            ]}
            {...rest}
        />
    );
}

export default SocialTemplatesTable;